<mat-card class="slidecontent"   >
  <div class="docheader">

   <div class="mark">

    <div class="checktask">
      <mat-icon>check_circle_outline</mat-icon>
    </div>
    <div class="txt">
      Mark as complete
    </div>
   </div>



    <button mat-icon-button  matTooltip="Link Process Intelligence" 
    matTooltipClass="tooltip" color=""  class="mlr10" (click)="showIntelligence(true)" ><mat-icon>link</mat-icon>
  </button>

    <button mat-icon-button  matTooltip="Linked Process Intelligence" 
           matTooltipClass="tooltip" color="primary" class="mlr10" [matMenuTriggerFor]="appMenu" ><mat-icon>link</mat-icon>
    </button>
    <mat-menu #appMenu="matMenu" xPosition="before" >
      <button mat-menu-item color="primary" class="linked" ><mat-icon>link</mat-icon> Real Estate PI linked</button>
      <button mat-menu-item  ><mat-icon>wrap_text</mat-icon> Replace PI</button>
      <button mat-menu-item><mat-icon>remove_circle_outline</mat-icon> Remove PI</button>
    </mat-menu>
          
    <div class="closedetail">
      <button mat-icon-button (click)="closedetail(close)" ><mat-icon>close</mat-icon></button>
    </div>

  </div>
  <div class="detailtabs userdetails" >
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="Detail"> 
          <div class="detail">

            <div class="taskLocation">
              <span>Core</span>
              <mat-icon>keyboard_arrow_right</mat-icon>
              <span>Family</span>
              <mat-icon>keyboard_arrow_right</mat-icon>
              <span>See how easy is to customize</span>

            </div>


            <form  class="fix-mat-form-field" >
              <mat-form-field class="example-full-width">
                  <mat-label>Task Name</mat-label>
                  <input matInput placeholder="Task Name" value="See how easy it is to customize Copper ">
              </mat-form-field>
              <div class="subtaskHolder"  >
                <div class="rep">
                  <div class="start">
                    <mat-icon>subdirectory_arrow_right</mat-icon>
                  </div>
                  <!-- <mat-checkbox></mat-checkbox> -->
                  <mat-form-field class="example-full-width">
                    <mat-label>Subtask</mat-label>
                    <input matInput placeholder="Add Subtask Name" value="First need to create profile">
                  </mat-form-field>
                  <button mat-icon-button class="" ><mat-icon > person_add</mat-icon></button>
                 
                  <button mat-icon-button class="remove" ><mat-icon >remove_circle_outline</mat-icon></button>
                </div>
                <div class="rep">
                  <div class="start">
                    <mat-icon>subdirectory_arrow_right</mat-icon>
                  </div>
                 <!-- <mat-checkbox></mat-checkbox> -->
                  <mat-form-field class="example-full-width">
                    <mat-label>Subtask</mat-label>
                    <input matInput placeholder="Add Subtask Name" value="Add people as a contact">
                  </mat-form-field>
                  <button mat-icon-button class="" ><mat-icon > person_add</mat-icon></button>
                  <button mat-icon-button class="remove" ><mat-icon >remove_circle_outline</mat-icon></button>
                </div>
              </div>

              <button class="subtask" (click)="showSubTask()" mat-button color="primary" > <mat-icon>add</mat-icon> Subtask </button>


              <mat-form-field>
                  <mat-label>Task Type</mat-label>
                  <mat-select value="" >
                    <mat-option value="" >To Do</mat-option>
                    <mat-option value="">Document</mat-option>
                    <mat-option value="">Appointment</mat-option>
                    <mat-option value="" > Phone Call</mat-option>
                    <mat-option value="">Email</mat-option>
                    <mat-option value="">Meeting</mat-option>
                    <mat-option value="">Other</mat-option>
                  </mat-select>
                </mat-form-field>  
                
                <div class="two">
                  <mat-form-field class="example-full-width">
                      <mat-label>Due Date</mat-label>
                      <input matInput placeholder="Due Date" value="5/06/20">
                      <mat-icon matSuffix>date_range</mat-icon>
                    </mat-form-field>
                    <mat-form-field class="example-full-width">
                      <mat-label>Time</mat-label>
                      <input matInput placeholder="Time" value="11:30 PM">
                      <mat-icon matSuffix>query_builder</mat-icon>
                    </mat-form-field>
                </div>
                
                <div class="tschedule">
                  <mat-form-field>
                    <mat-label>Schedule By</mat-label>
                    <mat-select value="" >
                      <mat-option value="" >Specific Date </mat-option>
                      <mat-option value="">Recurring</mat-option>
                      <mat-option value="">According to another task</mat-option>
                    </mat-select>
                  </mat-form-field>  

                  <div class="selectedSchedule bydate">
                    <label>Schedule task by specific date</label>
                    
                    <div class="specific">

                      <mat-form-field class="datefield">
                        <mat-label>Schedule date</mat-label>
                        <input matInput [matDatepicker]="picker">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>

                      <div class="field">
                        <!-- <label>Schedule Time</label> -->
                        <ngx-timepicker-field ></ngx-timepicker-field>
                    </div>
                  
                    </div>
                    
                  </div>

                  <div class="selectedSchedule byrecurring">
                    <label>Recurring</label>
                    
                    <div class="specific">

                      <mat-form-field class="datefield">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="picker2">
                        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
                      </mat-form-field>

                      <div class="fieldr">
                        <mat-form-field>
                        <mat-label>Repeat every</mat-label>
                        <mat-select value="" >
                          <mat-option value="" >1</mat-option>
                          <mat-option value="">2</mat-option>
                          <mat-option value="">3</mat-option>
                          <mat-option value="">4</mat-option>
                        </mat-select>
                      </mat-form-field> 
                    </div>

                      <div class="fieldr">
                        <mat-form-field>
                        <mat-label>Repeat</mat-label>
                        <mat-select value="" >
                          <mat-option value="" >day</mat-option>
                          <mat-option value="">week</mat-option>
                          <mat-option value="">month</mat-option>
                          <mat-option value="">year</mat-option>
                        </mat-select>
                      </mat-form-field> 
                    </div>
                  
                    </div>

                    <div class="everyday">

                      <label class="checkmark">
                        <input type="checkbox" checked="checked">
                        <span class="">M</span>
                      </label>
                      <label class="checkmark">
                        <input type="checkbox" checked="checked">
                        <span class="">T</span>
                      </label>
                      <label class="checkmark">
                        <input type="checkbox" checked="checked">
                        <span class="">W</span>
                      </label>
                      <label class="checkmark">
                        <input type="checkbox" checked="checked">
                        <span class="">T</span>
                      </label>

                      <label class="checkmark">
                        <input type="checkbox" checked="checked">
                        <span class="">F</span>
                      </label>
                      <label class="checkmark">
                        <input type="checkbox" checked="checked">
                        <span class="">S</span>
                      </label>
                      <label class="checkmark">
                        <input type="checkbox" checked="checked">
                        <span class="">S</span>
                      </label>

                    </div>

                    <p class="occurs" >Occurs every ...</p>

                  </div>

                  <div class="selectedSchedule byanothertask">
                    <label>According to another task</label>
                    
                    <div class="specific">

      

                      <div class="fieldr">
                        <mat-form-field>
                        <mat-label>Due</mat-label>
                        <mat-select value="" >
                          <mat-option value="" >1</mat-option>
                          <mat-option value="">2</mat-option>
                          <mat-option value="">3</mat-option>
                          <mat-option value="">4</mat-option>
                        </mat-select>
                      </mat-form-field> 
                    </div>

                    <div class="fieldr">
                      <mat-form-field>
                      <mat-label>Days</mat-label>
                      <mat-select value="" >
                        <mat-option value="" >Before</mat-option>
                        <mat-option value="">After</mat-option>
                      </mat-select>
                    </mat-form-field> 
                  </div>

                  <div class="fieldr">
                    <mat-form-field class="">
                      <mat-label>Due date</mat-label>
                      <input matInput [matDatepicker]="picker3">
                      <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                      <mat-datepicker #picker3></mat-datepicker>
                    </mat-form-field>
                  </div>
                    
                  
                    </div>
                    <div class="fullw">
                      <mat-form-field>
                      <mat-label>Task under </mat-label>
                      <mat-select value="" >
                        <mat-option value="" >Core</mat-option>
                        <mat-option value="">Contact</mat-option>
                        <mat-option value="">Company</mat-option>
                      </mat-select>
                    </mat-form-field> 
                  </div>
                    <div class="fullw">
                      <mat-form-field>
                      <mat-label>Select task</mat-label>
                      <mat-select value="" >
                        <mat-option value="" >See how easy it is to customize Copper </mat-option>
                        <mat-option value="">Start to diagnose covid patients</mat-option>
                      </mat-select>
                    </mat-form-field> 
                  </div>
                  

                  </div>

                </div>

                <div class="two">
                  <mat-form-field>
                    <mat-label>Assign To </mat-label>
                    <mat-select value="" multiple >
                      <mat-option value="" >Matt</mat-option>
                      <mat-option value="">Johan</mat-option>
                      <mat-option value="">Robert</mat-option>
                    </mat-select>
                  </mat-form-field>  
                  <mat-form-field>
                    <mat-label>Priority</mat-label>
                    <mat-select value="" >
                      <mat-option value="" >ASAP</mat-option>
                      <mat-option value="">Soon</mat-option>
                      <mat-option value="">Postpone</mat-option>
                      <mat-option value="">Other</mat-option>
                    </mat-select>
                  </mat-form-field>  

                </div>
    
                <div class="reminder">
                  <div class="remind">
                    Reminder
                    <mat-slide-toggle color="primary" ></mat-slide-toggle>
                  </div>  

                  <mat-radio-group color="primary" aria-label="Select an option">
                    <mat-radio-button value="1">Before 30 minutes</mat-radio-button>
                    <mat-radio-button value="2">Before 1 day</mat-radio-button>
                  </mat-radio-group>
                  <a href="#" class="custom" >Custom</a>
                </div>


                <div class="two">
                  <mat-form-field>
                    <mat-label>Type</mat-label>
                    <mat-select value="" >
                      <mat-option value="" >ECM</mat-option>
                      <mat-option value="">Signashare</mat-option>
                    </mat-select>
                  </mat-form-field>  
                  <mat-form-field>
                    <mat-label>Owner</mat-label>
                    <mat-select value="" >
                      <mat-option value="" >Matt</mat-option>
                      <mat-option value="">James</mat-option>
                    </mat-select>
                  </mat-form-field>  

                </div>

                <mat-form-field>
                  <mat-label>Description</mat-label>
                  <textarea matInput
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="3"
                            cdkAutosizeMaxRows="5"></textarea>
                </mat-form-field>

                <div class="two">
                  <mat-form-field class="example-full-width">
                      <mat-label>Last Touch</mat-label>
                      <input matInput placeholder="Last Touch" value="">
                      
                    </mat-form-field>
                    <mat-form-field class="example-full-width">
                      <mat-label>Next Touch</mat-label>
                      <input matInput placeholder="Next Touch" value="">
                      
                    </mat-form-field>
                </div>

            </form>
          </div>
         

      </mat-tab>

      <mat-tab label="Activity">

        <div class="detail">
          <div class="history">
            <div class="title">
              <h3>Note History</h3>
              <span class="count">2</span>
            </div>
            <div class="historylist">
                <div class="list">
                  <div class="info noteby">
                    <p class="by">HankPym <span>11/30/2018</span></p>
                    <p>When two parties reach an agreement on a transaction 
                      that gives one party the capital to purchase a home or 
                      other form of property</p>
                  </div>
                  <button mat-icon-button>
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                <div class="list">
                  <div class="info noteby">
                    <p class="by">HankPym <span>11/30/2018</span></p>
                    <p>When two parties reach an agreement on a transaction 
                      that gives one party the capital to purchase a home or 
                      other form of property</p>
                  </div>
                  <button mat-icon-button>
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>                  
            </div>
          </div>

        </div>

      </mat-tab>

    </mat-tab-group>
  </div>
  <div class="actionBtn">
    
    <button mat-flat-button class="cancel" (click)="closedetail(close)"  >Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit"  color="primary">Save</button>
    </div>
</mat-card>

<div class="documentOverlay"  (click)="closedetail(close)" ></div>
